import {
    Typography,
    IconButton,
    Grid,
    Paper,
    useTheme,
    Button,
    Popper,
    Grow,
    ClickAwayListener,
    MenuList,
    MenuItem,
    Box,
    Pagination,
    keyframes,
    useMediaQuery
} from '@mui/material'
import {
    KeyboardArrowDown,
    KeyboardArrowUp,
    Search,
} from '@mui/icons-material'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';


import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import Contacts from '../HomePage/contacts';
import { alert_outlined, goal, heart_outlined, smile_outlined, star_outlined, vision } from '../../../assets/icons';
import { how_is_event_going } from '../../../assets/backgrounds';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import TeamCarousel from '../AboutUs/team';
import { BoxAnimationStyle, PaginationItemStyle } from './styled';
import ReportingBig from './reportingBig';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



const HowIsEventGoing = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Як відбувається захід?", urlSlug: "" },
    ]);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        document.title = `Як відбувається захід?`;

    }, []);

    const bounce = keyframes`
        0% { transform: translateY(0); }
        50% { transform: translateY(7px); }
        100% { transform: translateY(0); }
    `;

    return (
        <>
            <HideForms />
            <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ mt: { xs: "11px", md: "28px", lg: "20px" }, pb: { xs: "43px", lg: "120px" } }}>
                <Grid item xs={4} md={5} lg={12} >
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ background: palette.primary.dark, mt: { xs: "28px", lg: "20px" }, borderRadius: "8px" }}>
                    <BoxAnimationStyle isOpen={isOpen} >
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box sx={{ width: { xs: "342px", lg: "600px" }, mt: { xs: "14px", md: "24px", lg: "43px" }, ml: { xs: "6px", md: "25px", lg: "45px" } }}>
                                <Typography
                                    variant="h2"
                                    fontFamily="Druk Wide, sans-serif"
                                    fontWeight="bold"
                                    sx={{
                                        fontSize: { xs: "20px", md: "18px", lg: "h2.fontSize" },
                                        lineHeight: { xs: "21px", lg: "38px" }
                                    }}
                                    textAlign={{ xs: "center", md: "start" }}
                                >
                                    Зазирнімо за лаштунки подій!
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontFamily="Fixel Display, sans-serif"
                                    sx={{
                                        fontSize: { xs: "12px", lg: "h4.fontSize" },
                                        lineHeight: { xs: "20px", lg: "28px" },
                                        mt: { xs: "8px", lg: "16px" }
                                    }}
                                >
                                    Щомісяця в різних містах України ви можете відвідати наші події, які поєднують атмосферу українських цінностей, творчість і обмін ідеями. Після участі ви маєте змогу приєднатися до нашої спільноти, де ми пропонуємо унікальні можливості від нашої організації та партнерів.
                                </Typography>
                            </Box>
                            <Box sx={{ display: { xs: "none", md: "block" }, width: { md: "379", lg: "667px" }, height: { md: "205px", lg: "363px" } }}>
                                <img
                                    loading="eager" src={how_is_event_going} alt="how_is_event_going" style={{ width: "inherit", height: "inherit" }} />
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "space-between" }, flexWrap: "wrap", p: { xs: "20px 14px 40px 14px", md: "20px 33px 40px 33px", lg: "38px 60px 87px 60px" } }}>
                            <Box
                                sx={{
                                    width: { xs: "332px", lg: "585px" },
                                    height: { xs: "181px", lg: "318px" },
                                    background: palette.text.secondary,
                                    borderRadius: { xs: "17px", lg: "30px" },
                                    p: { xs: "27px 7px 0px 21px", md: "17px 32px 0px 24px", lg: "31px 73px 125px 38px" }
                                }}
                            >
                                <Typography variant='h3' fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "16px", lg: "24px" }} lineHeight={{ xs: "21px", lg: "38px" }} color={palette.primary.dark}>
                                    Давай співпрацювати!
                                </Typography>
                                <Typography variant='h4' fontFamily="Fixel Display, sans-serif" fontWeight="600" fontSize={{ xs: "13px", lg: "20px" }} lineHeight={{ xs: "16px", lg: "28px" }} color={palette.background.default} sx={{ mt: { xs: "9px", md: "6px", lg: "0px" } }}>
                                    Ми відкриті до нових партнерств. Разом ми можемо створити нові можливості для молоді, втілити сміливі ідеї та розповісти світу про Україну та її культуру.
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: { xs: "332px", lg: "585px" },
                                    height: { xs: "181px", lg: "318px" },
                                    background: palette.text.secondary,
                                    borderRadius: { xs: "17px", lg: "30px" },
                                    p: { xs: "27px 41px 0px 21px", md: "17px 41px 0px 21px", lg: "31px 73px 125px 38px" },
                                    mt: { xs: "11px", md: "0px" }
                                }}
                            >
                                <Typography variant='h3' fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "16px", lg: "24px" }} lineHeight={{ xs: "21px", lg: "38px" }} color={palette.primary.dark}>
                                    Реалізовані проєкти
                                </Typography>
                                <Typography variant='h4' fontFamily="Fixel Display, sans-serif" fontWeight="600" fontSize={{ xs: "13px", lg: "20px" }} lineHeight={{ xs: "16px", lg: "28px" }} color={palette.background.default} sx={{ mt: { xs: "9px", md: "6px", lg: "0px" } }}>
                                    Перегляньте наші реалізовані проєкти та дізнайтеся, як ми втілюємо ідеї в життя. Надихайтеся результатами та долучайтеся до змін разом із нами!
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton disableRipple
                            sx={{
                                width: { xs: "20px", md: "24px", lg: "34px" },
                                height: { xs: "20px", md: "24px", lg: "34px" },
                                display: (isOpen == false ? "inline-flex" : "none"),
                                position: "absolute",
                                left: { xs: "172px", md: "362px", lg: "640px" }, bottom: "10px",
                                border: `2px solid #fff`,
                                p: "0px",
                                mb: "5px",
                                animation: `${bounce} 1s infinite ease`,
                            }}
                            onClick={() => { setIsOpen(!isOpen) }}
                        >
                            <KeyboardArrowDown sx={{ width: { xs: "20px", lg: "30px" }, height: { xs: "20px", lg: "30px" } }} />
                        </IconButton>
                        <IconButton disableRipple
                            sx={{
                                width: { xs: "20px", md: "24px", lg: "34px" },
                                height: { xs: "20px", md: "24px", lg: "34px" },
                                display: (isOpen == true ? "inline-flex" : "none"),
                                position: "absolute",
                                left: { xs: "172px", md: "362px", lg: "640px" }, bottom: "10px",
                                border: `2px solid #fff`,
                                p: "0px"
                            }}
                            onClick={() => { setIsOpen(!isOpen) }}
                        >
                            <KeyboardArrowUp sx={{ width: { xs: "20px", lg: "30px" }, height: { xs: "20px", lg: "30px" } }} />
                        </IconButton>
                    </BoxAnimationStyle>
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", md: "56px", lg: "65px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" sx={{ fontSize: { xs: "24px", md: "28px", lg: "h2.fontSize" } }}>
                        Відчуй атмосферу
                    </Typography>
                </Grid>
                {(isXl || isLg || isMd) && <ReportingBig rowsPerPage={10} />}
                {isXs && <ReportingBig rowsPerPage={5} />}
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Контакти */}
                <Contacts />
            </Grid >
        </>
    )
}

export default HowIsEventGoing